module.exports = __webpack_public_path__ + "static/img/img04.9d67932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsCenter/img/img04.jpg
// module id = RB0I
// module chunks = 1